import { connect } from 'react-redux'
import { loadUserFavourites, getUserFavIds } from 'Modules/user/favourites/actions'
import { openModal } from 'Modules/modals/actions'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import { getUserIsOneOfAgentAdminSupport } from 'Modules/user/data/selectors'

import Favourite from './Favourite'

const mapStateToProps = state => ({
  favPageData: state.userFavourites.favPageData,
  isFetching: state.userFavourites.isFetching,
  userFavs: state.userFavourites.userFavs,
  isMobile: state.app.isMobile,
  isMobileApp: state.app.isMobileApp,
  isUserAgentAdminSupport: getUserIsOneOfAgentAdminSupport(state),
})

const actions = {
  loadUserFavourites,
  getUserFavIds,
  openModal,
  googleAnalyticsEvent,
}

export default connect(mapStateToProps, actions)(Favourite)

